#import "./MediaFull.graphql"
#import "./TimestampsFull.graphql"
#import "./SearchIndexFull.graphql"

fragment ApplicationFull on Application {
  id
  tShirt {
    size
    gender
  }
  categories {
    type
    topped
  }
  competitionId
  handlerId
  dogId
  paidAt
  amountPaid
  note
  audio {
    ...MediaFull
  }
  team
  gdprApprovedAt
  recordingApprovedAt
  ...TimestampsFull
  ...SearchIndexFull
}
